export const SHOP = {
  navHome: 'nav-link-home',
  navMenu: 'nav-link-menu',
  navOrders: 'nav-link-orders',
  navContact: 'nav-link-contact',
  navBrand: 'nav-brand',
  navMobileToggle: 'nav-mobile-toggle',

  heroCta: 'hero-cta',
  heroSecondaryCta: 'hero-secondary-cta',
  heroTitle: 'hero-title',

  menuSection: 'menu-section',
  menuCategoryButton: 'menu-category-button',
  cakesCategoryButton: 'cakes-category-button',

  ordersSection: 'orders-section',
  orderFormName: 'order-form-name',
  orderFormEmail: 'order-form-email',
  orderFormPhone: 'order-form-phone',
  orderFormOccasion: 'order-form-occasion',
  orderFormDate: 'order-form-date',
  orderFormDescription: 'order-form-description',
  orderFormSubmit: 'order-form-submit',
  orderFormSuccess: 'order-form-success',

  contactSection: 'contact-section',
  contactPhone: 'contact-phone',
  contactAddress: 'contact-address',
  contactInstagram: 'contact-instagram',
  contactFacebook: 'contact-facebook',
  contactTiktok: 'contact-tiktok',
  contactEmail: 'contact-email',

  newsletterInput: 'newsletter-input',
  newsletterSubmit: 'newsletter-submit',
  newsletterSuccess: 'newsletter-success',

  pralinySection: 'praliny-section',
  navPraliny: 'nav-link-praliny',

  testimonialsSection: 'testimonials-section',
};
